import React from 'react'
import {Box, ButtonBase, Typography} from '@mui/material'
import {IPassengerChartRouteSummary} from '@containers/monitoringPlatform/passengerCharts/types'
import {pluralVypusk} from '@containers/monitoringPlatform/passengerCharts/helpers/pluralVypusk'
import {routeNumber} from '@containers/monitoringPlatform/passengerCharts/helpers/routeNumber'
import {formatRange, formatTime} from '@containers/monitoringPlatform/passengerCharts/helpers/formatTime'
import Sparkline from '@containers/monitoringPlatform/passengerCharts/chart/Sparkline'
import VypuskChips from '@containers/monitoringPlatform/passengerCharts/overview/VypuskChips'
import sx from '@containers/monitoringPlatform/passengerCharts/overview/sx'

interface IProps {
	route: IPassengerChartRouteSummary
	onSelect: () => void
}

const RouteCard = ({route, onSelect}: IProps) => {
	const circle = route.busiestCircle
	const fullVypusky = route.vypusky.filter((v) => v.circlesTotal > 0 && v.circlesDone === v.circlesTotal).length

	return (
		<ButtonBase component="div" sx={sx.card} onClick={onSelect}>
			<Box sx={sx.head}>
				<Typography sx={sx.number}>№{routeNumber(route.routeName)}</Typography>
				<Box component="span" sx={sx.badge}>
					{route.vypusky.length} {pluralVypusk(route.vypusky.length)}
				</Box>
			</Box>
			<Typography sx={sx.muted} title={route.routeDescription ?? ''}>
				{route.routeDescription}
			</Typography>

			{circle && <Typography sx={sx.circleLabel}>
				Коло {circle.circle} · {formatRange(circle.from, circle.to)}
			</Typography>}
			<Sparkline
				frames={circle?.frames ?? []}
				from={circle?.from ?? 0}
				to={circle?.to ?? 1}
				height={70}
			/>

			<Box sx={sx.stats}>
				<span><Box component="b" sx={sx.statValue}>{route.peak ?? '—'}</Box>пік {formatTime(route.peakAt)}</span>
				<span><Box component="b" sx={sx.statValue}>{route.avg ?? '—'}</Box>сер.</span>
			</Box>

			<Box sx={sx.vypusky}>
				<Box sx={sx.stats}>
					<span>Випуски</span>
					<span>{fullVypusky}/{route.vypusky.length} повних</span>
				</Box>
				<VypuskChips vypusky={route.vypusky}/>
			</Box>
		</ButtonBase>
	)
}

export default RouteCard
